<div class="back-container" [class.collapsed]="isCollapsed">
  <span class="button-group">
    <!-- Botón regresar -->
    <div *ngIf="volver">
    <button 
      pButton pRipple 
      *ngIf="backButton" 
      #button 
      type="button" 
      class="btn-modern" 
      title="Regresar" 
      pTooltip="Regresar"
      tooltipPosition="right">
      <fa-icon [icon]="['fas', 'angle-left']"></fa-icon>
    </button>
  </div>
    <!-- Botón inicio -->
    <button 
      pButton pRipple 
      class="btn-modern" 
      pTooltip="Inicio" 
      tooltipPosition="right"
      title="Inicio" 
      routerLink="/quality/dashboard">
      <fa-icon [icon]="['fas', 'home']"></fa-icon>
    </button>
  </span>
</div>
